import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_PRATICA_IRU_CUSTOMER } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDPraticaIruCustomerState extends EntityState<IID_PRATICA_IRU_CUSTOMER, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_PRATICA_IRU_CUSTOMER , realtimeEntity: 'IID_PraticaIruCustomer'})
@InterfaceDataStore(InterfaceName.IID_PRATICA_IRU_CUSTOMER)
export class IIDPraticaIruCustomerStore extends EntityStore<IIDPraticaIruCustomerState> {
  constructor() {
    super([]);
  }
}
